import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4","key":"svg-0"}]]

/**
 * IconCornerUpLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLXVwLWxlZnQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDE4di02YTMgMyAwIDAgMCAtMyAtM2gtMTBsNCAtNG0wIDhsLTQgLTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/corner-up-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerUpLeft = createReactComponent('outline', 'corner-up-left', 'CornerUpLeft', __iconNode);

export default IconCornerUpLeft;